
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/integrations/apps/[integration]",
      function () {
        return require("private-next-pages/integrations/apps/[integration].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/integrations/apps/[integration]"])
      });
    }
  